import {AfterViewInit, Component, inject, OnInit, signal} from '@angular/core';
import {gsap} from 'gsap';
import {TranslateModule} from "@ngx-translate/core";
import {AccountService} from "../../../services/account/account.service";
import {SafeHtmlPipe} from "../../../pipes/safe-html.pipe";
import {YouTubePlayer} from "@angular/youtube-player";
import { TypewriterComponent } from '../../../components/typewriter/typewriter-component';

@Component({
  selector: 'app-home-main',
  imports: [
    TranslateModule,
    SafeHtmlPipe,
    TypewriterComponent,
  ],
  templateUrl: './home-main.component.html',
  styles: ``
})
export class HomeMainComponent implements OnInit, AfterViewInit {
  account = inject(AccountService);

  youtubeId = signal('YtcqKYAgZoU');
  videoWidth = signal(700);
  videoHeight = signal(400);

  ngOnInit() {
    this.#setVideoWidth();
  }

  ngAfterViewInit() {
    const tl = gsap.timeline();

    tl.from('.home-main-1', {
      opacity: 0,
      x: -100,
      duration: 0.6,
    }).from('.home-main-2', {
      opacity: 0,
      y: 100,
      duration: 0.2,
    }, '-=0.2').from('.home-main-3', {
      opacity: 0,
      y: 80,
      duration: 0.2,
    }, '-=0.1').from('.home-main-4', {
      opacity: 0,
      y: 80,
      duration: 0.2,
    }, '-=0.1').from('.home-main-5', {
      opacity: 0,
      y: 80,
      duration: 0.2,
    })
  }

  #setVideoWidth(): void {
    setTimeout(() => {
      if (window.innerWidth <= 700) {
        this.videoWidth.set(343);
        this.videoHeight.set(196);
      }
    }, 50);
  }

  async showAction(): Promise<void> {
    await this.account.showAction();
  }
}
